module.exports = __webpack_public_path__ + "static/3-291fad7dfec18bb2daaa086a4d848208.jpeg";